import type { Country } from "../../types/common";
import { getRolesFromSessionStorage } from "../../utils/userHelper";
import { DownloadJsonButton } from "../DownloadJsonButton/DownloadJsonButton";
import { Norway } from "../Icons/Flags/Norway";
import { Spain } from "../Icons/Flags/Spain";
import { Sweden } from "../Icons/Flags/Sweden";
import { Finland } from "../Icons/Flags/Finland";
import { ProcessHeader } from "./styles";

const roles = getRolesFromSessionStorage();

export const OverviewHeader = (props: {
  country: Country;
  label: string;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  flow: any;
}) => {
  const { country, label, flow } = props;

  const getFlag = () => {
    switch (country) {
      case "ES":
        return <Spain />;
      case "SE":
        return <Sweden />;
      case "NO":
        return <Norway />;
      case "FI":
        return <Finland />;
      default:
        return null;
    }
  };

  const getCountrySpecificRoles = (country: Country): string[] => {
    switch (country) {
      case "ES":
        return ["admin-es", "caseworker-es", "admin-all", "reader-all"];
      case "SE":
        return ["admin-se", "caseworker-se", "admin-all", "reader-all"];
      case "NO":
        return ["admin-no", "caseworker-no", "admin-all", "reader-all"];
      case "FI":
        return ["admin-fi", "caseworker-fi", "admin-all", "reader-all"];
      default:
        return [];
    }
  };

  return (
    <ProcessHeader>
      <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 8 }}>
        {getFlag()}
        {label}
      </div>
      {
        // Show "Download Application Data" link for authorized roles based on country
        (() => {
          // Disable download for refund process
          if (flow.caseData.flowDefinitionId === "refund") return false;

          const countrySpecificRoles = getCountrySpecificRoles(country);

          if (Array.isArray(roles)) {
            return roles.some((role: string) => countrySpecificRoles.includes(role));
          }
          if (typeof roles === "string") {
            return countrySpecificRoles.includes(roles);
          }
          return false;
        })() && <DownloadJsonButton flow={flow} />
      }
    </ProcessHeader>
  );
};
